import React, { useLayoutEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import SearchApplicantStep from '../../../CompensationContainer/Steps/SearchApplicantStep';
import { searchForApplicant, setApplicantIsAdult } from '../../../../redux/modules/searchApplicant';
import { setLanguage, updateAccidentForm } from '../../../../redux/modules/accidentClaim';

const AccidentSearchApplicantStep = ({ goNext, blockNextSteps, step, params }) => {
  const { i18n } = useTranslation();
  const currentLanguage = useRef(i18n.language);
  const dispatch = useDispatch();

  const [dataForSearch, setDataForSearch] = useState({
    pnum: '',
    bdate: null,
    ssn: '',
    policy: '',
  });

  const {
    isSearching,
    searchData: { customError, applicant },
    language,
  } = useSelector(
    (store) => store.searchApplicant,
    shallowEqual,
  );

  useLayoutEffect(() => {
    dispatch(setLanguage(language || currentLanguage.current));
  }, [dispatch, language]);

  return (
    <SearchApplicantStep
      goNext={goNext}
      blockNextSteps={blockNextSteps}
      step={step}
      setStepNavigationBox={params.setStepNavigationBox}
      dataForSearch={dataForSearch}
      setDataForSearch={setDataForSearch}
      isLoading={isSearching}
      params={params}
      applicant={applicant}
      customError={customError}
      title="claim.claimTitle"
      searchForApplicant={searchForApplicant}
      setApplicantIsAdult={setApplicantIsAdult}
      updateForm={updateAccidentForm}
    />
  );
};

AccidentSearchApplicantStep.propTypes = {
  goNext: PropTypes.func.isRequired,
  blockNextSteps: PropTypes.func.isRequired,
  step: PropTypes.shape({
    claimForm: PropTypes.string.isRequired,
    n: PropTypes.number.isRequired,
  }).isRequired,
  params: PropTypes.shape({
    setStepNavigationBox: PropTypes.func.isRequired,
  }).isRequired,
};

export default AccidentSearchApplicantStep;
